const Warehouse = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">Warehousing </h1>
      </div>
      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
        <p>
        Companies today are under an enormous pressure to capitalise on evolving business trends 
        and make use of integrated logistics and dynamic sourcing, while simultaneously increasing 
        efficiency and reducing costs. To meet these challenges, TCS provides a broad suite of innovative
         applications that enables organisations to modernise their supply chain processes by adding
          cloud-based warehouse management capabilities, which includes:
        </p>
        <p>
         
        </p>
        <ul className="list-disc list-inside">
          <li>Managing warehouses nationwide</li>
          <li>Temperature controlled and ambient warehousing</li>
          <li>In-house WMS is compatible with other ERPs through EDI</li>
          <li>Reverse logistics</li>
          <li>Primary & secondary distribution</li>
          <li>Value added services</li>
          <li>Focused Verticals</li>
          <li>Healthcare & Pharma</li>
          <li>FMCG</li>
          <li>Automobiles</li>
          <li>Telecom</li>
          <li> Fashion & Retail</li>
        </ul>
       
      </div>
    </div>
  );
};

export default Warehouse;
